import * as React from 'react';
import { FormSectionBase, FormSectionBaseState } from '../Types/FormSectionBase';
import { CheckBoxGroup } from 'sos-common/js/components/FormControls/CheckBoxGroup';
import { CheckBox } from 'sos-common/js/components/FormControls/CheckBox';
import { FieldName, ApplicationType, FormType } from '../Types/Intyg.enums';
import { FormField } from 'sos-common/js/commonTypes/formField.types';
import { RefSetter } from '../Utils/RefSetter';
import { ApiService } from '../Services/intyg.api.service';
import { IKeyValue } from '../Types/ansokan.types';

export interface ITaEmotIntygetProps {}
export interface ITaEmotIntygetState extends FormSectionBaseState {}

enum LocalFieldName {
  TaEmotIntygetCheckboxGroup = 'TaEmotIntygetCheckboxGroup',
}

export default class TaEmotIntyget extends FormSectionBase<ITaEmotIntygetProps, ITaEmotIntygetState> {
  constructor(props: ITaEmotIntygetProps) {
    super(props);

    this.fieldRefs.set(LocalFieldName.TaEmotIntygetCheckboxGroup, React.createRef<CheckBoxGroup>());

    this.state = {
      errors: this.emptyErrorsMap,
    };
  }

  onChangeCheckboxGroup = (field: FormField<string[]>) => {
    const {
      onChangeCheckboxGroupValue,
      updateModelAsBatch,
      updateModelUsingKeyValue,
      model,
      applicationType,
      ansokanId,
      formType,
    } = this.context;

    const batchArray: IKeyValue[] = [];

    if (!field.value.includes(FieldName.SkickaPost)) {
      if (model.adresser !== null) {
        if (applicationType === ApplicationType.Eservice) {
          model.adresser.forEach((adress) => {
            ApiService.call.deleteAddress(ansokanId, adress.id);
          });
        }
        batchArray.push({ key: 'adresser', value: null });
      }
      batchArray.push({ key: FieldName.AntalSvenskaTillFolkbokforing, value: 0 });
      batchArray.push({ key: FieldName.AntalEngelskaTillFolkbokforing, value: 0 });
      batchArray.push({ key: FieldName.SkickaTillFolkbokforing, value: false });
    } else {
      batchArray.push({ key: FieldName.SkickaTillFolkbokforing, value: true });
    }

    //Some form types does not have a language picker but they have predefined languages that the intyg can be sent in.
    //The following control sets the correct values for booleans pdfEngelska and pdfSvenska if the intyg is requested
    //by pdf.
    const skickaPdf = field.value.includes(FieldName.SkickaPdf);

    switch (formType) {
      case FormType.Intyg_om_AT_tjanstgoring:
        batchArray.push({ key: FieldName.PdfEngelska, value: skickaPdf });
        break;
      case FormType.Intyg_om_forskrivningsratt:
      case FormType.Intyg_om_kontaktlinsbehorighet:
        batchArray.push({ key: FieldName.PdfSvenska, value: skickaPdf });
        break;
      case FormType.Intyg_for_legitimation_inom_EU:
      case FormType.Intyg_for_aktuell_legitimation:
      case FormType.Artikel_33:
        break;
    }

    updateModelAsBatch(batchArray);

    this.onChangeField(field, onChangeCheckboxGroupValue);
  };

  hiddenLeveransInput = () => {
    const { applicationType, model, Translate } = this.context;
    const leveransSatt = [];

    if (model.skickaPdf) {
      switch (applicationType) {
        case ApplicationType.Eservice:
          leveransSatt.push(Translate('somdigitaldokument'));
        case ApplicationType.Webform:
          leveransSatt.push(Translate('sompdf'));
      }
    }

    if (model.skickaPost) leveransSatt.push(Translate('papper'));
    if (leveransSatt.length === 0) return null;
    return leveransSatt.join(', ');
  };

  public render() {
    const { Translate, applicationType } = this.context;
    const hiddenLeveransVal = this.hiddenLeveransInput();
    const pdfLabel =
      applicationType === ApplicationType.Eservice ? Translate('somdigitaldokument') : Translate('sompdf');
    return (
      <RefSetter fieldRefs={this.fieldRefs}>
        <section className="m-b-4">
          <h3 className="like-a-label">
            {Translate('valjleverans')} {'(obligatoriskt)'}
          </h3>
          <CheckBoxGroup
            fieldName={LocalFieldName.TaEmotIntygetCheckboxGroup}
            onChange={this.onChangeCheckboxGroup}
            value={this.getCheckboxGroupValue([FieldName.SkickaPdf, FieldName.SkickaPost])}
            isRequired={true}
            useChildrensFieldNames={true}
            errorMessage={this.getErrorMessage(LocalFieldName.TaEmotIntygetCheckboxGroup)}>
            <CheckBox stringValue={FieldName.SkickaPdf} fieldName={FieldName.SkickaPdf} label={pdfLabel} />
            <CheckBox stringValue={FieldName.SkickaPost} fieldName={FieldName.SkickaPost} label={Translate('papper')} />
          </CheckBoxGroup>
        </section>
        {applicationType === ApplicationType.Webform && hiddenLeveransVal && (
          <input type="hidden" name="leveranssatt_checkbox" value={hiddenLeveransVal} />
        )}
      </RefSetter>
    );
  }
}
